import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('group_groupname_has_been_successfully_updated'),
    subTitle: defineMessage('the_following_workflows_are_using_this_group'),
    description: defineMessage('changes_may_take_a_few__sts_by_clicking_restart'),
    imageAlt: defineMessage('restart_workflow'),
    confirmButton: defineMessage('ok'),
};
